import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from '@mui/material';
import theme from './theme';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';

import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { Provider as ReduxProvider } from 'react-redux';

import { store } from './store/store.js';

import { FlagProvider } from '@unleash/proxy-client-react';
import { SnackbarProvider } from 'notistack';
import { InMemoryWebStorage, WebStorageStateStore } from 'oidc-client-ts';

import App from './App';
import './i18n.ts';

const oidcConfig: AuthProviderProps =
    import.meta.env.VITE_DEBUG === 'true' ? {
        authority: import.meta.env.VITE_AUTH_URL + 'realms/' + import.meta.env.VITE_AUTH_REALM,
        client_id: 'scoreg-frontend',
        // TODO: redirect to requested url
        redirect_uri: import.meta.env.VITE_BASE_URL + 'begin',
        // silent_redirect_uri: import.meta.env.VITE_BASE_URL + 'silent-renew.html',
        automaticSilentRenew: true,
        // TODO: activate for test/production
        userStore: new WebStorageStateStore({ store: new InMemoryWebStorage }),
    } :
        {
            authority: import.meta.env.VITE_AUTH_URL + 'realms/' + import.meta.env.VITE_AUTH_REALM,
            client_id: 'scoreg-frontend',
            // TODO: redirect to requested url
            redirect_uri: import.meta.env.VITE_BASE_URL + 'begin',
            // silent_redirect_uri: import.meta.env.VITE_BASE_URL + 'silent-renew.html',
            automaticSilentRenew: true,
            // TODO: activate for test/production
            userStore: new WebStorageStateStore({ store: new InMemoryWebStorage }),
        };

console.log(import.meta.env.VITE_APP_TITLE)

const flagConfig = {
    url: import.meta.env.VITE_UNLEASH_PROXY_URL, // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
    clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY, // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
    refreshInterval: import.meta.env.VITE_UNLEASH_REFRESH_INTERVAL, // How often (in seconds) the client should poll the proxy for updates
    appName: 'scoreg', // The name of your application. It's only used for identifying your application       
};

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
        <StrictMode>
            <FlagProvider config={flagConfig}>
                <ThemeProvider theme={theme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de" >
                        <AuthProvider {...oidcConfig}>
                            <ReduxProvider store={store}>
                                <SnackbarProvider maxSnack={5} autoHideDuration={2000} >
                                    <App />
                                </SnackbarProvider>
                            </ReduxProvider>
                        </AuthProvider>
                    </LocalizationProvider>
                </ThemeProvider>
            </FlagProvider>
        </StrictMode>,
    )
}